import styled from 'styled-components';

import { OnboardingPage } from '@/pages/Onboarding/components/Page';

export const PageStyles = styled(OnboardingPage)`
  .setting-up-title {
    margin: 32px auto 8px;
  }

  .setting-up-subtitle {
    margin-bottom: 20px;
  }

  .setting-up-user-reviews {
    margin: 24px 0 0;
  }

  ion-footer {
    padding-bottom: 30px;
  }
`;
